var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2603_2781)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.60749 3.25032C5.76459 4.09322 5.76464 5.44979 5.76459 8.16305L5.76459 15.8371C5.76459 18.5504 5.76459 19.907 6.60753 20.7499C7.4504 21.5928 8.80698 21.5928 11.5202 21.5928L12.4795 21.5928C15.1927 21.5928 16.5493 21.5928 17.3922 20.7499C18.235 19.907 18.235 18.5504 18.235 15.8372L18.2351 8.16306C18.2351 5.4498 18.2351 4.09324 17.3922 3.25032C16.5493 2.40743 15.1927 2.40743 12.4795 2.40743L11.5202 2.40743C8.80699 2.40743 7.45038 2.40743 6.60749 3.25032ZM14.3977 6.03565C14.8119 6.03565 15.1477 5.69986 15.1477 5.28565C15.1477 4.87143 14.8119 4.53565 14.3977 4.53565L9.60133 4.53564C9.18711 4.53565 8.85133 4.87143 8.85133 5.28564C8.85133 5.69986 9.18711 6.03565 9.60133 6.03564L14.3977 6.03565ZM11.9993 18.7155C12.794 18.7154 13.4382 18.0712 13.4382 17.2765C13.4382 16.4819 12.794 15.8376 11.9994 15.8376C11.2046 15.8377 10.5605 16.4819 10.5604 17.2766C10.5604 18.0712 11.2046 18.7155 11.9993 18.7155Z",
    fill: "#4E4E4E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2603_2781"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon-phone.5df50defb1c64a0d5b0f17839d44a5e1.svg";
export { ForwardRef as ReactComponent };